/**
 * @description src entry
 * @author wangfupeng
 */

import module from './module/index'

export default module
